import React from 'react';
import { EntityType } from '../types';
import { Avatar } from '@mui/material';
import AbcIcon from '@mui/icons-material/Abc';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ShareIcon from '@mui/icons-material/Share';
import EventIcon from '@mui/icons-material/Event';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PinIcon from '@mui/icons-material/Pin';

export const DataTypeAvatar = ({ type }: { type: EntityType }) => {
	if (
		type === EntityType.PropertyDefinitionString ||
        type === EntityType.PropertyDefinitionText ||
        type === EntityType.PropertyDefinitionSelectString
	) {
		return (
			<Avatar sx={{ bgcolor: 'primary.main', width: 28, height: 28 }}>
				<AbcIcon sx={{ fontSize: 16 }} />
			</Avatar>
		);
	}
	if (type === EntityType.PropertyDefinitionBoolean) {
		return (
			<Avatar sx={{ bgcolor: 'success.main', width: 28, height: 28 }}>
				<ToggleOnIcon sx={{ fontSize: 18 }} />
			</Avatar>
		);
	}
	if (
		type === EntityType.PropertyDefinitionBelongsTo ||
        type === EntityType.PropertyDefinitionHas
	) {
		return (
			<Avatar sx={{ bgcolor: 'info.main', width: 28, height: 28 }}>
				<ShareIcon sx={{ fontSize: 16 }} />
			</Avatar>
		);
	}
	if (type === EntityType.PropertyDefinitionDate) {
		return (
			<Avatar sx={{ bgcolor: 'error.main', width: 28, height: 28 }}>
				<EventIcon sx={{ fontSize: 16 }} />
			</Avatar>
		);
	}
	if (type === EntityType.PropertyDefinitionDatetime) {
		return (
			<Avatar sx={{ bgcolor: 'error.main', width: 28, height: 28 }}>
				<AccessTimeIcon sx={{ fontSize: 16 }} />
			</Avatar>
		);
	}
	if (type === EntityType.PropertyDefinitionNumber) {
		return (
			<Avatar sx={{ bgcolor: 'success.main', width: 28, height: 28 }}>
				<PinIcon sx={{ fontSize: 16 }} />
			</Avatar>
		);
	}
	return (
		<Avatar sx={{ bgcolor: 'grey.700', width: 28, height: 28 }}>
			<AbcIcon sx={{ fontSize: 16 }} />
		</Avatar>
	);
};